import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Text } from "@cars24/turbo-web/lib/text";
import Link from "./images/link.svg";
import { getLogoURL } from "../../../constants/url-constants";

const StateChallanInfoCard = ({ title = "", list = [], showImage = false, isCarsLogo = false }) => {

    const { tokens } = useTokens();

    return (
        <div styleName={"styles.wrapper"}>
            {isCarsLogo && <img src={getLogoURL()} height={40} styleName={"styles.logo"} />}
            {showImage && <img src={Link} height={48} width={48} />}
            <Text size="350" fontWeight="semibold" color={tokens.text_default_text_primary} as="h3">{title}</Text>
            <div styleName={"styles.listWrapper"}>
                {
                    list.map(({ description = "", title: text = "" }, index) => {
                        return (
                            <div styleName={"styles.listItem"} key={index}>
                                <Text size="250" fontWeight="semibold" color={tokens.text_brand_text_accent}>{index + 1}</Text>
                                {description ? <p dangerouslySetInnerHTML={{ __html: description }} /> : <p>{text}</p>}
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

StateChallanInfoCard.propTypes = {
    title: PropTypes.string,
    list: PropTypes.array,
    showImage: PropTypes.bool,
    isCarsLogo: PropTypes.bool
};

export default StateChallanInfoCard;
